// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import i18n from "@helpers/i18n.js";

import {
  defaultMessages,
  message as ResponseMessages,
} from "../enums/responseMessages.js";
import { SIGN_IN_ENDPOINT, SIGN_IN_USER_ENDPOINT } from "../Endpoints/Account";
import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//--start 1.LOGIN
// ## Login Request
// responseCheckSignIn: Sign'in başarılı olarak döndürüldüğü isteğe meta.signedIn true ekleyin.
const responseCheckSignIn = [
  {
    meta: {
      isSignedIn: true,
    },
    controls: [ResponseMessages.OK],
    message: {
      text: i18n.t("account.signIn.signInSuccess"),
      status: true,
      variant: "success",
      notification: true,
    },
  }, // işlem başarılı olduğunda yapılan kontrol
  {
    meta: {
      isSignedIn: false,
    },
    controls: [
      ResponseMessages.NOT_FOUND,
      ResponseMessages.ERRORLOGIN,
      ResponseMessages.LOGINERROR,
    ],
    message: {
      text: i18n.t("account.signIn.usernameOrPasswordIsWrong"),
      status: true,
      variant: "danger",
      notification: true,
    },
  }, // şifre veya email doğru değil ise.
];

//    sisteme giriş yapan request.
/**
 *
 * @param {{email: string, password: string}} form
 * @param {{params: object, query: object}} option
 *
 * @returns
 */
export const REQUEST_TO_SIGN_IN = async (form, loginType) => {
  $api.token = ""; // token sıfırlanır.
  const response = await $api.post(
    loginType === "admin" ? SIGN_IN_ENDPOINT() : SIGN_IN_USER_ENDPOINT(),
    form
  );
  const checker = await ResponseChecker(responseCheckSignIn, response);
  // Proje içinde kullanıcılacak token'ın yolunu aşağıya ekleyin.
  if (checker.meta?.isSignedIn) $api.token = checker.token;
  return checker;
};

//--end LOGIN

// ## Admin ForgetPassword
/**
 *
 * @param {{"email": "user@example.com"}} form
 *
 * @returns
 */
const forgetPassword = async (form) => {
  const response = await $api.post(Endpoints.Account.forgetPassword(), form);

  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Admin ResetPassword
/**
 *
 * @param {{"email": "user@example.com"}} form
 *
 * @returns
 */
const resetPassword = async (form) => {
  const response = await $api.post(Endpoints.Account.resetPassword(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default { forgetPassword, resetPassword };

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------
